var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0c8.836 0 16 7.164 16 16s-7.164 16-16 16S0 24.836 0 16 7.164 0 16 0",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.746 19.376v-6.75l5.63 3.37-5.63 3.38zm11.06-6.53c-.12-.82-.32-1.4-.57-1.84-.49-.87-1.02-1.03-2.1-1.09-1.08-.07-3.79-.1-6.13-.1-2.36 0-5.07.03-6.14.1-1.08.06-1.61.22-2.1 1.09-.51.87-.77 2.36-.77 4.99v.01c0 1.31.07 2.34.19 3.15.13.81.32 1.4.58 1.83.49.87 1.02 1.03 2.09 1.1 1.08.06 3.79.1 6.15.1 2.34 0 5.05-.04 6.13-.1 1.08-.07 1.61-.23 2.1-1.1.51-.86.76-2.36.76-4.98v-.01c0-1.31-.06-2.35-.19-3.15z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5b97476bb6f14ffba7ed1ad408932733.svg";
export { ForwardRef as ReactComponent };